module.exports = __webpack_public_path__ + "img/yw_sjjx.7ff88345.svg";